<template>
  <div class="registerInfo">
    <div class="header-wrapper">
      <div class="main-wrapper">
        <div class="logon-content" style="position: relative">
          <div style="font-size: 20px; color: white; position: absolute; bottom: 0px">
            <span>信息完善</span>
          </div>
        </div>
        <div class="phone-content" style="position: relative">
          <div style="position: absolute; bottom: 0px; right: 0px;">
            <span style="margin-right: 6px">{{ loginPhone }}</span>
            <span style="margin-right: 6px">|</span>
            <span id="exitRegister" @click="exitRegister">
              退出
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="main-wrapper">

      <div class="content-wrapper">
        <div>
          <el-form ref="form" :model="form" :rules="rules" label-width="210px">

            <div class="item-wrapper">
              <div class="item-title" style="font-size: 17px">
                <span style="color: #3888d7; font-weight: bold">|</span>
                <span style="margin-left: 2px; color: #333333">企业信息</span>
              </div>

              <div class="item-content">
                <el-form-item label="公司名称" prop="name">
                  <el-input v-model="form.name" type="text"
                            placeholder="请填写公司完整的名称，与营业执照一致"
                            :readonly="true"
                            style="width: 420px">
                  </el-input>
                </el-form-item>

                <el-form-item label="统一社会信用代码" prop="uscc">
                  <el-input v-model="form.uscc" type="text" style="width: 420px"
                            placeholder="请填写15或18位阿拉伯数字或大写字母"
                            :readonly="fieldDisable"
                            maxlength="18" >
                  </el-input>
                  <el-link :underline="false" @click="demoPicturePreview('/static/images/register/统一社会信用代码.jpg')" type="primary">查看示例</el-link>
                </el-form-item>

<!--                <el-form-item label="营业执照" prop="usccUpload">-->
<!--                  <el-link v-if="!fieldDisable" :underline="false" @click="demoPicturePreview('/static/images/register/营业执照.jpg')" type="primary">查看示例</el-link>-->
<!--                  <el-upload-->
<!--                    action="#"-->
<!--                    ref="usccUpload"-->
<!--                    list-type="picture-card"-->
<!--                    :limit='1'-->
<!--                    :file-list="this.form.usccImages"-->
<!--                    :disabled="fieldDisable"-->
<!--                    accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"-->
<!--                    :http-request="usccUpload"-->
<!--                    :on-change="beforeUsccUpload"-->
<!--                    :on-exceed="handlerUploadExceed"-->
<!--                    :auto-upload="false">-->
<!--                    <i slot="default" class="el-icon-plus"></i>-->
<!--                    <div v-if="!fieldDisable" class="el-upload__tip" slot="tip">只能上传jpg/jpeg/png文件，且不超过1M</div>-->
<!--                    <div slot="file" slot-scope="{file}">-->
<!--                      <img-->
<!--                        class="el-upload-list__item-thumbnail"-->
<!--                        :src="file.url" alt="">-->
<!--                      <span class="el-upload-list__item-actions">-->
<!--                        <span-->
<!--                          class="el-upload-list__item-preview"-->
<!--                          @click="handlePictureCardPreview(file)">-->
<!--                          <i class="el-icon-zoom-in"></i>-->
<!--                        </span>-->
<!--                        <span-->
<!--                          v-if="!disabled && !fieldDisable"-->
<!--                          class="el-upload-list__item-delete"-->
<!--                          @click="handleUsccRemove(file)">-->
<!--                          <i class="el-icon-delete"></i>-->
<!--                        </span>-->
<!--                      </span>-->
<!--                    </div>-->
<!--                  </el-upload>-->

                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
<!--                </el-form-item>-->

                <el-form-item label="公司地址" prop="address">
                  <el-input v-model="form.address" type="text" style="margin-top: 10px; width: 420px;"
                            placeholder="请填写公司办公地址">
                  </el-input>
                </el-form-item>

                <el-form-item label="联系电话" prop="telephone">
                  <el-input v-model="form.telephone" type="text"
                            placeholder="请填写联系电话，格式：区号-电话号码"
                            style="width: 420px">
                  </el-input>
                </el-form-item>

                <el-form-item label="邮箱地址" prop="email">
                  <el-input v-model="form.email" type="text"
                            placeholder="请填写邮箱地址，用于接收电子发票"
                            style="width: 420px"></el-input>
                </el-form-item>
              </div>
            </div>

            <div class="item-wrapper">
              <div class="item-title" style="font-size: 17px">
                <span style="color: #3888d7; font-weight: bold">|</span>
                <span style="margin-left: 2px; color: #333333">联系人信息</span>
              </div>

              <div class="item-content">
                <el-form-item label="联系人姓名" prop="managerName">
                  <el-input v-model="form.managerName" type="text"
                            placeholder="请填写联系人姓名"
                            style="width: 420px"></el-input>
                </el-form-item>

                <el-form-item label="联系人手机号码" prop="managerPhone">
                  <el-input v-model="form.managerPhone" type="text" oninput="value=value.replace(/[^\d]/g,'')"
                            maxlength="11"
                            placeholder="请填写11位手机号码"
                            style="width: 420px"></el-input>
                </el-form-item>
              </div>
            </div>

            <div class="item-wrapper">
              <div class="item-title" style="font-size: 17px">
                <span style="color: #3888d7; font-weight: bold">|</span>
                <span style="margin-left: 2px; color: #333333">登录密码信息</span>
              </div>

              <el-form-item label="设置密码" prop="password">
                <el-input v-model="form.password" type="password"
                          placeholder="请填写登录密码"
                          show-password
                          style="width: 420px"></el-input>
              </el-form-item>

              <el-form-item label="确认密码" prop="confirmPassword">
                <el-input v-model="form.confirmPassword" type="password"
                          placeholder="请填写确认密码"
                          show-password
                          style="width: 420px"></el-input>
              </el-form-item>
              <div style="margin-left: 12px; font-size: 12px; color: #999;">
                密码格式要求：1.至少包含8个字符 2.至少包含一个小写字母 3.至少包含一个大写字母 4.至少包含一个数字包含 5.至少包含 !@#$%^&* 之中一个特殊字符
              </div>
            </div>
            <br>

            <div style="font-size: 16px; text-align: center; color: #666;">
              <el-checkbox v-model="form.isAgree">我已阅读并同意<a href="#" style="">《用户协议》</a></el-checkbox>
            </div>
          </el-form>
        </div>

        <div class="footer-wrapper">
          <div style="width: 300px; margin: 0px auto;">
            <el-button type="" style="width: 120px; margin-top: 12px; margin-left: 22px" @click="exitRegister">取 消</el-button>
            <el-button type="danger" style="width: 120px; margin-top: 12px;"
                       :disabled="!form.isAgree"
                       @click="submitForm">提 交</el-button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  checkPhone,
  checkEmail
} from '@/common/utils.js'
import {
  reqRegister,
} from '@/api'

export default {
  name: 'RegisterInfo',

  data() {
    // 校验营业执照图片
    // var checkUsccUpload = (rule, value, callback) => {
    //   setTimeout(() => {
    //     if (this.$refs.usccUpload.uploadFiles.length == 1) {
    //       callback()
    //     } else {
    //       callback(new Error('请上传营业执照'))
    //     }
    //   }, 100)
    // }

    // 校验确认密码
    var checkConfirmPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请填写确认密码'))
      }
      if (value.trim() != this.form.password.trim()) {
        return callback(new Error('确认密码与密码不一致'))
      }
      callback()
    }

    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      formData: '',
      loginPhone: '',
      form: {
        name: '', // 公司名称
        uscc: '', // 统一社会信用代码
        address: '', // 公司经营地址
        telephone: '', // 联系电话
        email: '', // 联系邮箱
        password: '', // 密码
        confirmPassword: '', // 确认密码
        managerName: '', // 管理人姓名
        managerPhone: '', // 管理人手机号
        isAgree: false // 是否同意协议
        // 以下信息在首次注册时无用
        // usccImages: [] // 营业执照图片
      },
      rules: {
        name: [
          { required: true, message: '请填写公司名称', trigger: 'blur' },
          { min: 6, max: 32, message: '长度在 6 到 32 个字符', trigger: 'blur' }
        ],
        uscc: [
          { required: true, pattern: /^[\u4e00-\u9fa5_\x00-\xffa-zA-Z0-9.·-]{15,18}$/, message: '请填写15或18位统一社会信用代码', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请填写公司地址', trigger: 'blur'}
        ],
        telephone: [
          { required: true, pattern: /^\d{3,4}-\d{7,8}$/, message: '请填写联系电话，示例格式020-88886666或0756-88886666', trigger: 'blur' }
        ],
        email: [
          { required: true, validator: checkEmail, trigger: 'blur' }
        ],
        password: [
          // { required: true, message: '请填写密码', trigger: 'blur' },
          { required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/, message: '密码格式不符合要求', trigger: 'blur' }
          // { min: 8, max: 16, message: '密码长度至少8字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: checkConfirmPassword, trigger: 'blur' }
        ],
        managerName: [
          { required: true, pattern: /^[\u4e00-\u9fa5_\x00-\xffa-zA-Z0-9.·-]+$/, message: '请填写管理人姓名', trigger: 'blur' }
        ],
        managerPhone: [
          { required: true, validator: checkPhone, trigger: 'blur' }
        ]
        // usccUpload: [
        //   { required: true, validator: checkUsccUpload }
        // ]
      }
    };
  },

  methods: {

    exitRegister () {
      let message = '确定取消注册吗'
      if (this.fieldDisable) {
        message = '确定退出吗'
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.removeItem('loginPhone')
        this.$router.replace('/register')
      }).catch(() => {
      })
    },

    submitForm () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.formData = new FormData()
          // this.$refs.usccUpload.submit()

          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }

          if (!(this.form.uscc.trim().length == 15 || this.form.uscc.trim().length == 18)) {
            await this.$alert('统一社会信用代码长度是15或18位，请修改', '信息有误', {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
            return
          }

          this.formData.append('name', this.form.name.trim())
          this.formData.append('uscc', this.form.uscc.trim())
          this.formData.append('address', this.form.address.trim())
          this.formData.append('telephone', this.form.telephone.trim())
          this.formData.append('email', this.form.email.trim())
          this.formData.append('managerName', this.form.managerName.trim())
          this.formData.append('managerPhone', this.form.managerPhone.trim())

          this.formData.append('password', this.form.password.trim())
          this.formData.append('loginPhone', this.loginPhone.trim())

          const loading = this.$loading({
            lock: true,
            text: '提交中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          const result = await reqRegister(this.formData, config)
          loading.close()
          if (result.code === 0) {
            await this.$alert('信息提交成功，感谢注册！', '注册成功', {
              confirmButtonText: '确定',
              callback: action => {
                sessionStorage.removeItem('loginPhone')
                this.$router.replace('/login')
              }
            })
          } else {
            await this.$alert('信息提交失败，请稍后重新再试！', '注册失败', {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
          }

        } else {
          await this.$alert('注册信息不完整，请完善后再提交！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return false
        }
      })

    },

    usccUpload (file) {
      this.formData.append('usccFiles', file.file);
    },

    // beforeUsccUpload(file) {
    //   return checkUploadFileSize(this, this.$refs.usccUpload, file, 1)
    // },
    //
    // handleUsccRemove (file) {
    //   removeUploadFile(this, this.$refs.usccUpload, file)
    // },
    //
    // handlePictureCardPreview (file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },

    demoPicturePreview (url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },

    // handlerUploadExceed (files) {
    //   handlerUploadExceed(this, 1)
    // },

  },

  async mounted () {
    this.form.name = sessionStorage.getItem('name')
    this.form.managerPhone = sessionStorage.getItem('loginPhone')
    this.loginPhone = sessionStorage.getItem('loginPhone')
  },

  computed: {
    fieldDisable () {
      return this.form.id !== 0 && this.form.status === 0
    }
  }
}
</script>

<style scoped>
  .registerInfo {
    background-color: #f1f1f1;
  }

  .header-wrapper {
    widht: 100%;
    height: 80px;
    background-color: #c13532;
    /*background-color: rgba(3, 3, 3, 0.86);*/
    border-bottom-color: #f9d993;
  }

  .logon-content {
    width: 240px;
    height: 40px;
    float: left;
    margin-top: 20px;
  }

  .phone-content {
    width: 260px;
    height: 40px;
    float: right;
    margin-top: 20px;
    color: white;
    font-size: 14px;
    text-align: right;
  }

  .main-wrapper {
    /*width: 60%;*/
    width: 960px;
    margin-left: auto;
    margin-right: auto;
  }

  .step-wrapper {
    margin: 28px 0px;
    height: 90px;
    background-color: #fff;
  }

  .content-wrapper {
    background-color: #fff;
  }

  .item-wrapper {
    padding: 40px 60px 0px 60px;
  }

  .item-title {
    /*border: 1px solid;*/
  }

  .item-content {
    margin: 20px 0px;
  }

  .footer-wrapper {
    width: 960px;
    height: 66px;
    /*background-color: #fff;*/
    /*border-width: 1px 0px 0px 0px;*/
    /*border-top-style: solid;*/
    /*border-top-color: #f3f3f3;*/
    /*box-shadow: 0px 0px 2px #888888;*/
    /*position: fixed;*/
    /*bottom: 0px;*/
  }

  #exitRegister:hover {
    cursor:pointer;
  }

</style>



// WEBPACK FOOTER //
// src/pages/RegisterInfo/RegisterInfo.vue